module.exports = __webpack_public_path__ + "img/na.0d45af21.svg";